import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";

export default function AgencyCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [owner, setOwner] = React.useState('');
    const navigate = useNavigate();

    let refName = React.useRef();
    let refSlug = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resOwner = await Utils.getOwnerAll();
                setOwner(resOwner);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = () => {
        let items = [];
        let checkboxes = document.getElementsByName('ownerIds[]');
        for (let i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].checked) {
                items.push({'ownerId': checkboxes[i].value});
            }
        }

        let name = refName.current.value;
        let slug = refSlug.current.value;
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Agency");
            refName.current.focus();
        }
        else if(!slug) {
            toast.error("กรุณาระบุ Slug");
            refSlug.current.focus();
        }
        else if(items.length <= 0) {
            toast.error("กรุณาระบุ สังกัด (Owner) อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');
                            let encryptChecked = document.getElementsByName('encryptChecked');

                            const body = {
                                name: name,
                                slug: slug,
                                status: statusChecked[0].checked ? 1:0,
                                isEncrypt: encryptChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                items: items
                            };
                            fetch(Config.url.API_URL +'/api/agency/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/agency', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onInputSlug = (e) => {
        if(e && e.target.value) {
            refSlug.current.value = Utils.slugString(e.target.value);
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Agency</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Agency <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="slug" className="form-label">Slugs <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="slug" ref={refSlug} maxLength={100} onKeyUp={e => onInputSlug(e)} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="ownerx" className="form-label">สังกัด (Owner) <span className="text-danger">*</span></label>
                                {
                                    owner.length <= 0 ? (<p>ไม่พบสังกัด</p>) :
                                    owner.map((row, index) => {
                                        let chkId = 'ownerCheck' + row.id;
                                                return (
                                                    <div key={index} className="form-check ms-2">
                                                        <input className="form-check-input" name="ownerIds[]" type="checkbox" value={row.id}
                                                               id={chkId} />
                                                        <label className="form-check-label" htmlFor={chkId}>
                                                            ({row.code}) {row.name}
                                                        </label>
                                                    </div>);
                                    })
                                }
                            </div>
                            <div className="col-12">
                                <label htmlFor="encryptCheckedx" className="form-label">Encrypt</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="encryptChecked" id="encryptChecked" defaultChecked={false} />
                                    <label className="form-check-label" htmlFor="encryptChecked"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/agency'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 